<template>
    <div
        class="empty-state"
        :style="rootStyles"
    >
        <img
            :src="svg.src"
            :alt="svg.alt || svg.name || 'Empty state image'"
            class="empty-state__image"
            :style="svg.styles || {}"
        >

        <div class="empty-state__content">
            <component
                :is="titleTag"
                v-if="title && title.text"
                class="empty-state__title"
                :class="title.className"
            >
                {{ title.text }}
            </component>

            <component
                :is="descriptionTag"
                v-if="description && description.text"
                class="empty-state__description"
                :class="description.className"
            >
                {{ description.text }}
            </component>

            <slot name="custom-content" />

            <div
                v-if="hasButtons"
                class="empty-state__buttons"
            >
                <slot name="buttons" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmptyState',

    props: {
        title: {
            type: Object,
            default: null
        },

        description: {
            type: Object,
            default: null
        },

        svg: {
            type: Object,
            required: true
        },

        rootStyles: {
            type: Object,
            default() {
                return {}
            }
        }
    },

    computed: {
        titleTag() {
            return this.title && this.title.tag
                ? this.title.tag
                : 'h2'
        },

        descriptionTag() {
            return this.description && this.description.tag
                ? this.description.tag
                : 'p'
        },

        hasButtons() {
            return Boolean(this.$slots.buttons)
        }
    }
}
</script>

<style scoped>
.empty-state {
    gap: 0;
    width: 100%;
    display: flex;
    max-width: 568px;
    align-items: center;
    flex-direction: column;
}

.empty-state__image {
    width: 100%;
    height: auto;
}

.empty-state__content {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    
}

.empty-state__title{
margin: 0;
text-align: center;
font-family: Inter;
font-weight: 600;
font-style: Semi Bold;
font-size: 30px;
leading-trim: NONE;
line-height: 38px;
letter-spacing: -0.3px;
text-align: center;

}
.empty-state__description {
    font-family: Inter;
    font-weight: 400;
    font-style: Regular;
    font-size: 15px;
    leading-trim: NONE;
    line-height: 23px;
    letter-spacing: 0px;
    text-align: center;
}

.empty-state__buttons {
    display: flex;
    align-self: stretch;
    align-items: flex-start;
    justify-content: center;
    gap: 20px;
    padding: 30px 0 40px;
}
</style>